import { Input } from 'almanac-ui/TextInputField/Input'
import Styles from './EditDrawer.module.scss'
import { EditDrawerProps } from './Types'
import { Drawer } from 'components/Drawer'
import { useState } from 'react'
import { Text } from 'blaze-ui/Text/Text'
import { useDeleteRecommendation } from 'hooks/queries/brainStrategicRecommendations/useDeleteRecommendation'
import { Button } from 'blaze-ui/Button'
import { Trash2 } from 'blaze-ui/icons'
import { useRootStore } from 'stores/RootStore'
import { reportError } from 'utils/error'
import { useUpdateRecommendation } from 'hooks/queries/brainStrategicRecommendations/useUpdateRecommendation'

const EditDrawer = ({ recommendation, brandKitId, ...props }: EditDrawerProps) => {
  const [recommendationText, setRecommendationText] = useState(recommendation.recommendation)
  const { drawersStore } = useRootStore()
  const { mutateAsync: deleteRecommendation, isLoading: isDeleting } = useDeleteRecommendation()
  const { mutateAsync: updateRecommendation, isLoading: isSaving } = useUpdateRecommendation()

  const handleDelete = async () => {
    if (isDeleting) return

    try {
      await deleteRecommendation({
        brandKitId,
        recommendationId: recommendation.id,
      })
      drawersStore.closeDrawer()
    } catch (error) {
      reportError(error)
    }
  }

  const handleSave = async () => {
    if (isSaving) return

    try {
      await updateRecommendation({
        brandKitId,
        recommendationId: recommendation.id,
        recommendation: recommendationText,
      })
      drawersStore.closeDrawer()
    } catch (error) {
      reportError(error)
    }
  }

  return (
    <Drawer.Root {...props} activeSnapPoint={1} snapPoints={[1]}>
      <Drawer.Overlay />
      <Drawer.Portal>
        <Drawer.Content fullHeight>
          <Drawer.InnerContent isSnappedTop>
            <Drawer.Top>
              <Drawer.Close position="left" />
              <Drawer.Title asChild>
                <Text variant="primary">Edit Recommendation</Text>
              </Drawer.Title>
              <Drawer.Action position="right" onPress={() => handleSave()} isDisabled={isSaving}>
                Save
              </Drawer.Action>
              <Drawer.Description />
            </Drawer.Top>

            <Drawer.ScrollableContainer snap={1}>
              <div className={Styles.content} data-autopilot-system-redesign="on">
                <Input
                  name="recommendationText"
                  aria-label="recommendationText"
                  isTextarea
                  autoFocus
                  rows={10}
                  value={recommendationText}
                  onChange={(e) => setRecommendationText(e.target.value)}
                />
                <Button variant="secondary" onPress={() => handleDelete()} frontIcon={Trash2} isDisabled={isDeleting}>
                  Delete
                </Button>
              </div>
            </Drawer.ScrollableContainer>
          </Drawer.InnerContent>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  )
}

export { EditDrawer }
